export function exists(value) {
    return value != null && value !== false;
}
//# sourceMappingURL=exists.js.map